import React from 'react'
import {Container} from 'react-bootstrap';

export const ProjectForm = () => {
  return (
    <Container className="mt-2 text-center">
      <h1>Inscribir proyecto</h1>
      <p>Para inscribir un proyecto con nosotros. Debes ingresar con tu pasaporte USM en el siguiente formulario.</p>
      <p>En caso de no poder ver el formulario, ingresar <a target='_blank' rel="noreferrer" href='https://forms.office.com/Pages/ResponsePage.aspx?id=dlZiAicyCkScaLttKd5CBqd1KdHLuyFFmqpedBwkazFUN1NUVUZQRUgyREM2VExDNTdRUThLQjFFRi4u&embed=true'>aquí.</a></p>
      <Container className="mt-5 mb-5 d-flex flex-column justify-content-between flex-sm-row" fluid>
          <iframe title="Form 2" style={{
            marginTop:"10px",
              width:"100%",
              height:"980px",
              marginwidth: "0", 
              marginheight: "0",
              maxWidth: "100%",
              maxHeight:"100vh",
              borderRadius: "10px",
              frameBorder: "0",
              allowFullScreen:true,
              "webkitallowfullscreen": true	,
              "mozallowfullscreen": true,
              "msallowfullscreen": true		
                      }}                        
              src={"https://forms.office.com/Pages/ResponsePage.aspx?id=dlZiAicyCkScaLttKd5CBqd1KdHLuyFFmqpedBwkazFUN1NUVUZQRUgyREM2VExDNTdRUThLQjFFRi4u&embed=true"}/>
      </Container>
    </Container>
  )
}